export default "__VITE_ASSET__BPydl8o1__"